(function(angular) {
  'use strict';
  var validationModule = angular.module('onvio.reports');

  validationModule.directive('validateBasisDate', validateBasisDate);

  validateBasisDate.$inject = [];

  function validateBasisDate() {
      return {
          restrict: 'A',
          require: 'ngModel',
          link: function(scope, element, attr, ctrl) {
              ctrl.$validators.basisDateInvalid = function(modelValue) {
                  var basisColumnsLength = 2;
                  if (modelValue) {
                      var basisColumns = getBasisDate(modelValue);
                      if (basisColumns.length === basisColumnsLength && isThirdInvalid(modelValue)) {
                          return validateMonth(basisColumns[0]) && validateYear(basisColumns[1]);
                      }
                      return false;
                  }
                  return true;
              };
          }
      };
  }

  function validateMonth(month) {
      var stringLength = 2;
      var firstMonth = 1;
      var lastMonth = 12;
      return month.length === stringLength && !isNaN(month) && month >= firstMonth && month <= lastMonth;
  }

  function validateYear(year) {
      return year.length === 4 && !isNaN(year);
  }

  function createBasisDate(value) {
      var basisColumns = [];
      basisColumns[0] = value.slice(0, 2);
      basisColumns[1] = value.slice(2, 6);

      return basisColumns;
  }

  function getThirdCharacter(value) {
      if (value.length === 7) {
          for (var i = 0; i < value.length; i++) {
              if (i === 2) {
                  return value[i];
              }
          }
      }
  }

  function getBasisDate(value) {
      var basisColumns = [];
      if (value.length === 6) {
          basisColumns = createBasisDate(value);
      } else if (value.length === 7) {
          var i = 3;
          value = value.slice(0, i - 1) + value.slice(i);
          basisColumns = createBasisDate(value);
      }
      return basisColumns;
  }

  function isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }

  function isThirdInvalid(value) {
      var n = getThirdCharacter(value);
      if (isNumber(n)) {
          return false;
      }
      return true;
  }

})(angular);
